import { useState } from "react";
import { useInView } from "@/shared/hooks/useInView";

export default function StoreHero({ src, isLoaded }: { src?: string; isLoaded: boolean }) {
    const [ref, inView] = useInView("200px");
    const [imgLoaded, setImgLoaded] = useState(false);

    if (!isLoaded) {
        return (
            <div className="store-hero" ref={ref as any}>
                <div className="store-hero__skeleton" />
            </div>
        );
    }

    if (!src) {
        return (
            <div className="store-hero">
                <div className="store-hero__placeholder">No hero image</div>
            </div>
        );
    }

    return (
        <div className="store-hero" ref={ref as any}>
            {!imgLoaded && <div className="store-hero__skeleton" />}
            {inView && (
                <img
                    src={src}
                    alt=""
                    className={imgLoaded ? "loaded" : ""}
                    onLoad={() => setImgLoaded(true)}
                    style={imgLoaded ? {} : { display: "none" }}
                />
            )}
        </div>
    );
}
